// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateIncidentIoEndpointMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  url: Types.Scalars["String"]["input"];
  token: Types.Scalars["String"]["input"];
}>;

export type CreateIncidentIoEndpointMutation = {
  __typename?: "Mutation";
  createIncidentIoEndpoint?: {
    __typename?: "IncidentIoEndpoint";
    id: string;
  } | null;
};

export type UpdateIncidentIoEndpointMutationVariables = Types.Exact<{
  incidentIoEndpointId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  url?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  token?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  enabled?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type UpdateIncidentIoEndpointMutation = {
  __typename?: "Mutation";
  updateIncidentIoEndpoint?: {
    __typename?: "IncidentIoEndpoint";
    id: string;
    name: string;
    url: string;
    disabledAt?: number | null;
    disabledReason?: string | null;
    consecutiveFailures: number;
    lastFailureAt?: number | null;
  } | null;
};

export type DeleteIncidentIoEndpointMutationVariables = Types.Exact<{
  incidentIoEndpointId: Types.Scalars["ID"]["input"];
}>;

export type DeleteIncidentIoEndpointMutation = {
  __typename?: "Mutation";
  deleteIncidentIoEndpoint?: {
    __typename?: "IncidentIoEndpoint";
    id: string;
  } | null;
};

export type TestIncidentIoEndpointMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  url?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  token?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  incidentIoEndpointId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type TestIncidentIoEndpointMutation = {
  __typename?: "Mutation";
  testIncidentIoEndpoint?: {
    __typename?: "WebhookTestResult";
    status: string;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorMessage?: string | null;
  } | null;
};

export const CreateIncidentIoEndpointDocument = gql`
  mutation CreateIncidentIoEndpoint(
    $organizationSlug: ID!
    $name: String!
    $url: String!
    $token: String!
  ) {
    createIncidentIoEndpoint(
      organizationSlug: $organizationSlug
      name: $name
      url: $url
      token: $token
    ) {
      id
    }
  }
`;
export type CreateIncidentIoEndpointMutationFn = Apollo.MutationFunction<
  CreateIncidentIoEndpointMutation,
  CreateIncidentIoEndpointMutationVariables
>;

/**
 * __useCreateIncidentIoEndpointMutation__
 *
 * To run a mutation, you first call `useCreateIncidentIoEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentIoEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentIoEndpointMutation, { data, loading, error }] = useCreateIncidentIoEndpointMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateIncidentIoEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIncidentIoEndpointMutation,
    CreateIncidentIoEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateIncidentIoEndpointMutation,
    CreateIncidentIoEndpointMutationVariables
  >(CreateIncidentIoEndpointDocument, options);
}
export type CreateIncidentIoEndpointMutationHookResult = ReturnType<
  typeof useCreateIncidentIoEndpointMutation
>;
export type CreateIncidentIoEndpointMutationResult =
  Apollo.MutationResult<CreateIncidentIoEndpointMutation>;
export type CreateIncidentIoEndpointMutationOptions =
  Apollo.BaseMutationOptions<
    CreateIncidentIoEndpointMutation,
    CreateIncidentIoEndpointMutationVariables
  >;
export const UpdateIncidentIoEndpointDocument = gql`
  mutation UpdateIncidentIoEndpoint(
    $incidentIoEndpointId: ID!
    $name: String
    $url: String
    $token: String
    $enabled: Boolean
  ) {
    updateIncidentIoEndpoint(
      incidentIoEndpointId: $incidentIoEndpointId
      name: $name
      url: $url
      token: $token
      enabled: $enabled
    ) {
      id
      name
      url
      disabledAt
      disabledReason
      consecutiveFailures
      lastFailureAt
    }
  }
`;
export type UpdateIncidentIoEndpointMutationFn = Apollo.MutationFunction<
  UpdateIncidentIoEndpointMutation,
  UpdateIncidentIoEndpointMutationVariables
>;

/**
 * __useUpdateIncidentIoEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentIoEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentIoEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentIoEndpointMutation, { data, loading, error }] = useUpdateIncidentIoEndpointMutation({
 *   variables: {
 *      incidentIoEndpointId: // value for 'incidentIoEndpointId'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      token: // value for 'token'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateIncidentIoEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIncidentIoEndpointMutation,
    UpdateIncidentIoEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateIncidentIoEndpointMutation,
    UpdateIncidentIoEndpointMutationVariables
  >(UpdateIncidentIoEndpointDocument, options);
}
export type UpdateIncidentIoEndpointMutationHookResult = ReturnType<
  typeof useUpdateIncidentIoEndpointMutation
>;
export type UpdateIncidentIoEndpointMutationResult =
  Apollo.MutationResult<UpdateIncidentIoEndpointMutation>;
export type UpdateIncidentIoEndpointMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateIncidentIoEndpointMutation,
    UpdateIncidentIoEndpointMutationVariables
  >;
export const DeleteIncidentIoEndpointDocument = gql`
  mutation DeleteIncidentIoEndpoint($incidentIoEndpointId: ID!) {
    deleteIncidentIoEndpoint(incidentIoEndpointId: $incidentIoEndpointId) {
      id
    }
  }
`;
export type DeleteIncidentIoEndpointMutationFn = Apollo.MutationFunction<
  DeleteIncidentIoEndpointMutation,
  DeleteIncidentIoEndpointMutationVariables
>;

/**
 * __useDeleteIncidentIoEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteIncidentIoEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncidentIoEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncidentIoEndpointMutation, { data, loading, error }] = useDeleteIncidentIoEndpointMutation({
 *   variables: {
 *      incidentIoEndpointId: // value for 'incidentIoEndpointId'
 *   },
 * });
 */
export function useDeleteIncidentIoEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIncidentIoEndpointMutation,
    DeleteIncidentIoEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteIncidentIoEndpointMutation,
    DeleteIncidentIoEndpointMutationVariables
  >(DeleteIncidentIoEndpointDocument, options);
}
export type DeleteIncidentIoEndpointMutationHookResult = ReturnType<
  typeof useDeleteIncidentIoEndpointMutation
>;
export type DeleteIncidentIoEndpointMutationResult =
  Apollo.MutationResult<DeleteIncidentIoEndpointMutation>;
export type DeleteIncidentIoEndpointMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteIncidentIoEndpointMutation,
    DeleteIncidentIoEndpointMutationVariables
  >;
export const TestIncidentIoEndpointDocument = gql`
  mutation TestIncidentIoEndpoint(
    $organizationSlug: ID!
    $url: String
    $token: String
    $incidentIoEndpointId: ID
  ) {
    testIncidentIoEndpoint(
      organizationSlug: $organizationSlug
      url: $url
      token: $token
      incidentIoEndpointId: $incidentIoEndpointId
    ) {
      status
      responseStatus
      responseBodyExcerpt
      errorMessage
    }
  }
`;
export type TestIncidentIoEndpointMutationFn = Apollo.MutationFunction<
  TestIncidentIoEndpointMutation,
  TestIncidentIoEndpointMutationVariables
>;

/**
 * __useTestIncidentIoEndpointMutation__
 *
 * To run a mutation, you first call `useTestIncidentIoEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestIncidentIoEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testIncidentIoEndpointMutation, { data, loading, error }] = useTestIncidentIoEndpointMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      url: // value for 'url'
 *      token: // value for 'token'
 *      incidentIoEndpointId: // value for 'incidentIoEndpointId'
 *   },
 * });
 */
export function useTestIncidentIoEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestIncidentIoEndpointMutation,
    TestIncidentIoEndpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestIncidentIoEndpointMutation,
    TestIncidentIoEndpointMutationVariables
  >(TestIncidentIoEndpointDocument, options);
}
export type TestIncidentIoEndpointMutationHookResult = ReturnType<
  typeof useTestIncidentIoEndpointMutation
>;
export type TestIncidentIoEndpointMutationResult =
  Apollo.MutationResult<TestIncidentIoEndpointMutation>;
export type TestIncidentIoEndpointMutationOptions = Apollo.BaseMutationOptions<
  TestIncidentIoEndpointMutation,
  TestIncidentIoEndpointMutationVariables
>;
